<template>
  <div v-if="regleFacturation">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ getTitle }}
              </h1>
              <breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <button class="button" @click="$router.go(-1)">
              {{ $t('general.button.cancel')}}
            </button>
            <button class="button is-addOrEdit" @click="save()">
              {{ $t('general.button.sauvegarder') }}
            </button>
            <button class="button btn-modal-annuler"
                    @click="checkPermissions(permPresse.maj) ?
                      showAddAttachmentModal() : showPopUp()">
              <b-icon icon="paperclip" type="is-default"></b-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
    <error-msg-component :messages="messages" class="mgt-20px" v-if="error"
                         :messagesChampsVide="messagesChampsVide"
                         :champsVide="champsVide"
                         :error="error"
                         :title="'general.problemOccurred'"
                         :withEmplyFields="true"
                         @close="error = $event"/>
    <div class="card mgt-20px">
      <header class="header-card">
        <p>
          {{ $t('addEditRegleFacturation.informationRegleFacturation.info')}}
        </p>
      </header>
      <div class="card-content is-marginless">
        <div class="columns">
          <b-field class="column is-4 obligatoire"
                   :label="$t('addEditRegleFacturation.informationRegleFacturation.codification')">
            <b-input type="text"
                     v-model="regleFacturation.code"></b-input>
          </b-field>
          <b-field class="column is-4 obligatoire"
                   :label="$t('addEditRegleFacturation.informationRegleFacturation.libelle')">
            <b-input type="text"
                     v-model="regleFacturation.libelle"></b-input>
          </b-field>
          <b-field class="column is-4 obligatoire"
                   :label="$t('addEditRegleFacturation.informationRegleFacturation.type')">
            <b-select expanded v-model="regleFacturation.type">
              <option :key="typeRegleFacturation.key"
                      :value="typeRegleFacturation.key"
                      v-for="typeRegleFacturation in listeTypeRegleFacturation">
                {{ $t(typeRegleFacturation.libelle) }}
              </option>
            </b-select>
          </b-field>
        </div>
      </div>
    </div>

    <div class="card mgt-20px">
      <header class="header-card">
        <p>
          {{ $t('addEditRegleFacturation.informationRegleFacturation.infoFacture')}}
        </p>
      </header>
      <qd-message :title="$t('addEditRegleFacturation.informationRegleFacturation.informations')"
                 type="is-info" class="mg-20px" :closable="false">
        {{ $t('addEditRegleFacturation.informationRegleFacturation.infoLogo') }}
      </qd-message>
      <div class="card-content is-marginless">
        <div class="columns is-multiline">
          <b-field class="column is-6"
                   :label="$t('addEditRegleFacturation' +
                    '.informationRegleFacturation.zoneInfoPaiement')">
            <qd-text-editor v-model="regleFacturation.facture.zoneInfoPaiement"/>
          </b-field>
          <b-field class="column is-6"
                   :label="$t('addEditRegleFacturation.informationRegleFacturation.piedPage')">
            <qd-text-editor v-model="regleFacturation.facture.piedPage" />
          </b-field>
          <b-field class="column is-6"
                   :label="$t('addEditRegleFacturation.' +
                    'informationRegleFacturation.zoneInfoDiverse')">
            <qd-text-editor v-model="regleFacturation.facture.zoneInfoDivers" />
          </b-field>
          <div class="column is-6 columns is-multiline">
            <b-field
              :label="$t('addEditRegleFacturation.informationRegleFacturation.sizeWidth')"
              class="column is-4">
              <b-input
                v-model.number="regleFacturation.facture.logoTailleX"
                type="number">
              </b-input>
            </b-field>
            <b-field
              :label="$t('addEditRegleFacturation.informationRegleFacturation.sizeHeight')"
              class="column is-4">
              <b-input
                v-model.number="regleFacturation.facture.logoTailleY"
                type="number">
              </b-input>
            </b-field>
          </div>
        </div>
      </div>
    </div>

    <div class="card mgt-20px">
      <header class="header-card mgb-20px">
        <p>
          {{ $t('addEditRegleFacturation.informationRegleFacturation.infoRelance')}}
        </p>
      </header>
      <qd-message :title="$t('addEditRegleFacturation.informationRegleFacturation.informations')"
                 type="is-info" class="mg-20px" :closable="false">
        {{ $t('addEditRegleFacturation.informationRegleFacturation.infoLogo') }}
      </qd-message>
      <qd-steps class="stepfullWidth" v-model="activeStep" :has-navigation="false"
        :animated="true" :rounded="true" mobile-mode="compact" label-position="bottom"
        :stepsItems="stepsItems">
        <template #relance1>
          <h1 class="title has-text-centered">{{ $t('addEditRegleFacturation' +
            '.informationRegleFacturation.relance1text') }}</h1>
          <setRelanceInformations :relance-informations="regleFacturation.relance1">
          </setRelanceInformations>
        </template>

        <template #relance2>
          <h1 class="title has-text-centered">{{ $t('addEditRegleFacturation' +
            '.informationRegleFacturation.relance2text') }}</h1>
          <setRelanceInformations :relance-informations="regleFacturation.relance2">
          </setRelanceInformations>
        </template>

        <template #relance3>
          <h1 class="title has-text-centered">{{ $t('addEditRegleFacturation' +
            '.informationRegleFacturation.relance3text') }}</h1>
          <setRelanceInformations :relance-informations="regleFacturation.relance3">
          </setRelanceInformations>
        </template>
      </qd-steps>
    </div>

    <div class="pdt-20px">
      <div class="card">
        <header class="header-card">
          <p>
            {{ $t('piecesJointes.attachments')}}
          </p>
        </header>
        <div class="card-content">
          <pieces-jointes :checkPermissions="true"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumb from '@/components/general/breadcrumb';
import genererRegleFacturation from '@/services/presse/regleFacturation/genererRegleFacturation';
import validationRegleFacturation from '@/services/presse/regleFacturation/validationRegleFacturation';
import translate from '@/services/presse/regleFacturation/translator';
import {
  TYPE_REGLE_FACTURATION,
} from '@/configuration/presse/regleFacturation/regleFacturationConf';
import { cloneDeep } from 'lodash';
import setRelanceInformations from '@/components/presse/regleFacturation/setRelanceInformations';
import piecesJointes from '@/components/general/piecesJointes';
import { createNamespacedHelpers } from 'vuex';
import messageSucces from '@/services/general/messageSucces';
import validationGeneral from '@/services/validation/validation';
import { create, update } from '@/api/presse/regleFacturation';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import { REGLE_FACTURATION } from '@/configuration/presse/permissionsPresseConf';
import { SET_REGLE_FACTURATION_COURANTE } from '@/store/modules/presse/regleFacturation-mutation-type';
import errorMsgComponent from '@/components/general/errorMsgComponent';

const Attachments = createNamespacedHelpers('attachments');
const Parametres = createNamespacedHelpers('parametres');
const Permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');
const RegleFacturation = createNamespacedHelpers('regleFacturation');

export default {
  name: 'm_regleFacturation',
  data() {
    return {
      regleFacturation: null,
      listeTypeRegleFacturation: TYPE_REGLE_FACTURATION,
      activeStep: 0,
      error: false,
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      permPresse: REGLE_FACTURATION,
    };
  },
  components: {
    breadcrumb,
    piecesJointes,
    setRelanceInformations,
    errorMsgComponent,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...RegleFacturation.mapGetters({
      regleFacturationCourante: 'regleFacturationCourante',
    }),
    getTitle() {
      if (this.$route.params.id) return this.$i18n.t('addEditRegleFacturation.titleEdit', { libelle: this.libelle });
      return this.$i18n.t('addEditRegleFacturation.titleAdd');
    },
    breadcrumb() {
      return [
        { title: this.$t('addEditRegleFacturation.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('addEditRegleFacturation.breadcrumb.parametrage'), route: { name: 'l.parametrage.general' }, isActive: false },
        { title: this.$t('addEditRegleFacturation.breadcrumb.liste'), route: { name: 'l.presse.regle_facturation' }, isActive: false },
        { title: this.getTitle, route: { name: '' }, isActive: true },
      ];
    },
    getReglesFacturation() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.regleFacturation);
    },
    stepsItems() {
      return [
        {
          name: 'relance1',
          step: 1,
          label: this.$t('addEditRegleFacturation'
          + '.informationRegleFacturation.relance1'),
          clickable: true,
        },
        {
          name: 'relance2',
          step: 2,
          label: this.$t('addEditRegleFacturation'
          + '.informationRegleFacturation.relance2'),
          clickable: true,
        },
        {
          name: 'relance3',
          step: 3,
          label: this.$t('addEditRegleFacturation'
          + '.informationRegleFacturation.relance3'),
          clickable: true,
        },
      ];
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreForce: 'loadParametreForce',
      loadParametres: 'loadParametres',
    }),
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
      showAddAttachmentModal: 'showAddModal',
      insertAttachments: 'insert',
      updateAttachments: 'update',
    }),
    ...RegleFacturation.mapMutations({
      setRegleFacturationCourant: SET_REGLE_FACTURATION_COURANTE,
    }),
    async save() {
      this.error = false;
      this.messages = [];
      this.messagesChampsVide = [];
      this.champsVide = [];
      const loadingComponent = this.$buefy.loading.open();
      try {
        let regleFacturation = cloneDeep(this.regleFacturation);
        if (!regleFacturation.id) {
          regleFacturation.societeId = this.societeActiveId;
          regleFacturation = (await create(regleFacturation)).data.result;
          await this.setAttachmentElementId({ id: regleFacturation.id });
          await this.insertAttachments(regleFacturation.id);
          messageSucces(this.$i18n.t('addEditRegleFacturation.success.add'));
        } else {
          if (!regleFacturation.societeId) regleFacturation.societeId = this.societeActiveId;
          regleFacturation = (await update(regleFacturation)).data.result;
          await this.updateAttachments(regleFacturation.id);
          messageSucces(this.$i18n.t('addEditRegleFacturation.success.edit'));
        }
        await this.loadParametreForce(typesParametres.PARAMETRES_KEYS.regleFacturation);
        await this.$router.push({ name: 'c.presse.regle_facturation-detail', params: { id: regleFacturation.id } });
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        if (e.response.data.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          validationRegleFacturation(e.response, this.messages);
          this.error = true;
          return;
        }
        throw e;
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.setAttachmentContext({ module: 'RegleFacturation' });
      this.setInformationPage(this.$t('pageParametrage.regleFacturation.edit'));
      if (this.regleFacturationCourante) {
        this.regleFacturation = cloneDeep(this.regleFacturationCourante);
        this.setRegleFacturationCourant(null);
      } else if (this.$route.params.id) {
        await this.loadParametres([typesParametres.PARAMETRES_KEYS.regleFacturation]);
        const regleFacturation = this.getReglesFacturation.find((el) => {
          return el.id === this.$route.params.id;
        });
        await this.setAttachmentElementId({ id: regleFacturation.id });
        this.regleFacturation = regleFacturation;
      } else {
        this.regleFacturation = genererRegleFacturation();
      }
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
